import { Box, Avatar, Typography } from '@mui/material'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import SysAdminUserActionBtn from './SysAdminUserActionBtn.jsx'
import { userButtonList } from '../../../components/utils/buttonList'
import CardWithSpace from '../../../components/Cards/CardWithSpace/index.jsx'
import {
  selectSystemAdminUsers,
} from '../../../redux/features/users/SystemAdminUsers/SystemAdminUsersSlice'
import { getFirstAndSecondCharacterOnly, isNotEmpty } from '../../../utils/helpers'
import HoverTooltip from '../../../components/PageHelpers/HoverTooltip.jsx'
import UseTranslation from '../../../hooks/UseTranslation.jsx'

const SystemAdminUsersList = () => {
  const systemAdminUsers = useSelector(selectSystemAdminUsers)
  const baseUri = process.env.REACT_APP_ROOT_ROUTE || ''
  const { t } = UseTranslation()
  const history = useHistory()

  const getUserStatus = (user) => (user?.active ? userButtonList[0] : userButtonList[1])

  const userProfileHandler = (user) => {
    history.push(`${baseUri}/user/${user.id}`)
  }

  return (
    <Box sx={styles.container}>
      {systemAdminUsers?.data?.map((user) => (
          <CardWithSpace key={user?.id} customStyle={styles.cardWithSpace}>
            <Box sx={styles.singleCard}>
              <Box sx={styles.info} onClick={() => userProfileHandler(user)}>
                <Box>
       <Avatar sx={styles.avatar}>
        {getFirstAndSecondCharacterOnly(user?.name)}
       </Avatar>
        </Box>

                <Box sx={styles.infoContainer}>
                 <Box sx={styles.nameUnit}>
            <Typography component={'span'}>{`${t?.['User Name']}`}</Typography>
            <HoverTooltip title={user?.name || `${t?.['No User Name']}`}>
            <Typography variant='body1'>
          { user?.name || `${t?.['No User Name']}`}
            </Typography>
            </HoverTooltip>
        </Box>

                 <Box sx={styles.infoUnit}>
            <Typography component={'span'}>{`${t?.email}`}</Typography>
            <HoverTooltip title={user?.email}>
            <Typography variant='body1'>
            {user?.email}
         </Typography>
            </HoverTooltip>
        </Box>
        <Box sx={styles.infoUnit}>
            <Typography component={'span'}>{`${t?.Company}`}</Typography>
            <HoverTooltip title={user?.company?.name}>
            <Typography variant='body1'>
            {user?.company?.name}
         </Typography>
            </HoverTooltip>
        </Box>
        <Box sx={styles.infoUnit}>
            <Typography component={'span'}>{`${t?.['User Type']}`}</Typography>
            <HoverTooltip title={user?.user_types}>
            <Typography variant='body1'>
            {user?.user_types}
         </Typography>
            </HoverTooltip>
        </Box>

        <Box sx={styles.statusReminderUnit}>
            <Typography component={'span'} sx={styles.statusLabel}>{`${t?.Status}`}</Typography>
            <Box sx={styles.tagsWrap}>
              <HoverTooltip title={getUserStatus(user)?.title}>
                <Box sx={user?.active ? styles.statusTagActive : styles.statusTagDisabled}>
                  <Box component="span" sx={user?.active ? styles.statusDotActive : styles.statusDotDisabled} />
                  <Typography component="span" sx={user?.active ? styles.statusTextActive : styles.statusTextDisabled}>
                    {t?.[getUserStatus(user)?.title]}
                  </Typography>
                </Box>
              </HoverTooltip>
              <HoverTooltip title={isNotEmpty(user?.subscription_reminder) ? t?.['Reminder Message'] : t?.['No Reminder']}>
                <Box
                        sx={user?.subscription_reminder
                          ? styles.subscriptionTagActive : styles.subscriptionTagDisabled}
                >
                  <Box
                    component="span"
                    sx={
                      user?.subscription_reminder
                        ? styles.subscriptionDotActive
                        : styles.subscriptionDotDisabled
                    }
                  />
                  <Typography
                    component="span"
                    sx={
                      user?.subscription_reminder
                        ? styles.subscriptionTextActive
                        : styles.subscriptionTextDisabled
                    }
                  >
                    {user?.subscription_reminder
                      ? t?.['Reminder Message']
                      : t?.['No Reminder']}
                  </Typography>
                </Box>
              </HoverTooltip>
            </Box>
          </Box>
              </Box>
              </Box>

              <SysAdminUserActionBtn
                data={user}
                status={getUserStatus(user)}
                statusButtonList={userButtonList}
                route={`edit-user/${user?.id}`}
                customStyle={styles.actionBtn}
              />
            </Box>
          </CardWithSpace>

      ))}
      </Box>
  )
}

const styles = {
  container: {
    padding: { xs: '10px 0px 0px', sm: '10px 0px', lg: '10px 0px' },
  },
  cardWithSpace: {
    padding: { xs: '10px 0px 0px', sm: '10px 0px', lg: '10px 0px' },
    width: '100%',
  },
  singleCard: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'white',
    fontSize: { xs: '14px', md: '16px' },
    padding: '20px',
    paddingRight: { xs: '10px', md: '0px' },
    margin: '10px 0',
    borderRadius: '12px',
    position: { xs: 'relative', sm: 'unset' },

  },
  info: {
    display: 'flex',
    flexDirection: { xs: 'row', sm: 'row' },
    justifyContent: 'space-between',
    alignItems: { xs: 'center', sm: 'center' },
    width: { xs: '90%', sm: 'calc(100% - 90px)' },
    cursor: 'pointer',
  },

  profileImage: {
    display: { xs: 'none', sm: 'block' },
    width: { sm: 50, md: 70 },
    height: { sm: 50, md: 70 },
    marginBottom: { xs: '10px', sm: 'unset' },
  },
  infoContainer: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', md: 'repeat(5, minmax(0, 1fr))' },
    columnGap: { md: '16px' },
    alignItems: 'center',
    width: '100%',
    marginLeft: { xs: '10px', md: '0px' },
  },
  avatar: {
    display: 'flex',
    bgcolor: '#FFC542',
    color: 'white',
    height: { xs: '50px', md: '64px' },
    width: { xs: '50px', md: '64px' },
    mr: { xs: '0px', md: '29px' },
    textTransform: 'uppercase',
    fontWeight: 800,
    fontSize: { xs: '16px', md: '25px' },
  },
  nameUnit: {
    display: 'flex',
    flexDirection: { xs: 'row', md: 'column' },
    justifyContent: { xs: 'flex-start', md: 'center' },
    maxWidth: '100%',
    width: '100%',
    minWidth: 0,
    alignItems: 'flex-start',
    '& p': {
      fontSize: { xs: '12px', md: '16px' },
      whiteSpace: { xs: 'unset', md: 'nowrap' },
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '100%',
      maxWidth: '100%',
      fontWeight: { xs: '600', md: '500' },
    },
    '& span': {
      display: { xs: 'none', md: 'block' },
      width: 'fit-content',
      fontSize: { xs: '12px', md: '14px' },
      opacity: '0.7',
      fontWeight: '500',
      color: 'text.hint',
      marginBottom: '10px',
      marginRight: { xs: '10px', md: '0px' },
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  infoUnit: {
    display: 'flex',
    flexDirection: { xs: 'row', md: 'column' },
    justifyContent: { xs: 'flex-start', md: 'center' },
    maxWidth: '100%',
    width: '100%',
    minWidth: 0,
    alignItems: 'flex-start',
    '& p': {
      fontSize: { xs: '12px', md: '16px' },
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '100%',
      maxWidth: '100%',
      marginBottom: { xs: '5px', md: '0px' },
    },
    '& span': {
      display: { xs: 'none', md: 'block' },
      width: '85%',
      fontSize: { xs: '12px', md: '14px' },
      opacity: '0.7',
      fontWeight: '500',
      color: 'text.hint',
      marginBottom: '10px',
      marginRight: { xs: '10px', md: '0px' },
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  statusReminderUnit: {
    display: 'flex',
    flexDirection: { xs: 'row', md: 'column' },
    justifyContent: { xs: 'flex-start', md: 'flex-start' },
    alignItems: { xs: 'center', md: 'flex-start' },
    maxWidth: '100%',
    width: '100%',
    minWidth: 0,
    gap: { xs: '10px', md: '8px' },
    '& span:first-of-type': {
      display: { xs: 'none', md: 'block' },
      fontSize: '14px',
      fontWeight: 500,
      color: 'text.hint',
      opacity: 0.8,
      marginBottom: 0,
    },
  },
  statusLabel: {
    flexShrink: 0,
  },
  tagsWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    flexWrap: 'wrap',
  },
  statusTagActive: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    backgroundColor: '#e6f7ed',
    color: '#1e7e34',
    padding: '4px 10px',
    borderRadius: '999px',
    width: 'fit-content',
  },
  statusTagDisabled: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    backgroundColor: '#f5f5f5',
    color: '#757575',
    padding: '4px 10px',
    borderRadius: '999px',
    width: 'fit-content',
  },
  statusDotActive: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: '#1e7e34',
    flexShrink: 0,
  },
  statusDotDisabled: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: '#757575',
    flexShrink: 0,
  },
  statusTextActive: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#1e7e34',
  },
  statusTextDisabled: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#757575',
  },
  subscriptionTagActive: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    backgroundColor: '#e6f7ed',
    color: '#1e7e34',
    padding: '4px 10px',
    borderRadius: '999px',
    width: 'fit-content',
  },
  subscriptionTagDisabled: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    backgroundColor: '#f5f5f5',
    color: '#757575',
    padding: '4px 10px',
    borderRadius: '999px',
    width: 'fit-content',
  },
  subscriptionDotActive: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: '#1e7e34',
    flexShrink: 0,
  },
  subscriptionDotDisabled: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: '#757575',
    flexShrink: 0,
  },
  subscriptionTextActive: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#1e7e34',
    '&::before': {
      content: '"🔔"',
      fontSize: '12px',
      marginRight: 1,
    },
  },
  subscriptionTextDisabled: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#757575',
    '&::before': {
      content: '"🔕"',
      fontSize: '12px',
      marginRight: 1,
    },
  },
  actionBtn: {
    position: { xs: 'absolute', md: 'unset' },
    top: { xs: '10px', md: 'unset' },
    right: { xs: '0px', md: 'unset' },
  },
}
export default SystemAdminUsersList
